import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';
import { ThemeProvider } from 'styled-components';

import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import SubheadingText from '@ui/atoms/SubheadingText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';
import FolxHeader from '@ui/molecules/FolxHeader';

import { DashboardContainer, StyledPageContainer } from '@ui/routes/Dashboard/DashboardRoute';

import spaced from '@ui/styled/Spaced';

import { keysToCamel } from '@utils/butter';

import Footer from '@components/WSFooter';

import { getThemeForFlow } from '@theme/FlowThemes';

const SpacedColumn = spaced<IFlexColumn>(FlexColumn);

interface IMedicationBillErrorContent {
	heading: string;
	body: string;
	subtext: string;
}

const MedicationBillError: FC = () => {
	const { pageContent } = useStaticQuery(
		graphql`
			{
				pageContent: butterPage(slug: { eq: "medication-bill-error" }) {
					heading
					subtext
				}
			}
		`
	);

	const { heading, subtext } = keysToCamel(pageContent) as IMedicationBillErrorContent;
	return (
		<ThemeProvider theme={getThemeForFlow('dashboard')}>
			<StyledPageContainer header={<FolxHeader />} footer={<Footer />}>
				<DashboardContainer removePadding={false}>
					<CenteredGridItem>
						<SpacedColumn gap="sm">
							<HeadingText>{heading}</HeadingText>
							<SubheadingText variant="normal">{subtext}</SubheadingText>
						</SpacedColumn>
					</CenteredGridItem>
				</DashboardContainer>
			</StyledPageContainer>
		</ThemeProvider>
	);
};

export default MedicationBillError;
